module.exports = __webpack_public_path__ + "static/ambient-4f2f9921d696903a7d9cc0b3681120cf.mp3";